<div class="container">
  <div class="header">
    <span class="label">{{ header }}</span>
    <cs-icon-button
      [attr.mat-dialog-close]="dialogRef ? '' : null"
      icon="fi-x"
      iconFontSize="12"
      size="12"
      color="secondary"
      (buttonClick)="onCancel()"
    ></cs-icon-button>
  </div>
  <div class="body-container">
    <div class="body">
      @if (icon) {
        <i class="icon" [class]="icon"></i>
      }
      @if (title) {
        <div class="label" [style.textAlign]="textAlign">{{ title }}</div>
      }
      @if (message) {
        @if (isArrayMessage()) {
          @for (item of message; track item) {
            <div class="text" [style.textAlign]="textAlign">{{ item }}</div>
          }
        } @else {
          <div class="text" [style.textAlign]="textAlign">{{ message }}</div>
        }
      }
    </div>
    <div class="btn">
      @if (cancelText) {
        <cs-button
          [attr.mat-dialog-close]="dialogRef ? '' : null"
          [label]="cancelText"
          color="secondary"
          (buttonClick)="onCancel()"
        ></cs-button>
      }
      @if (customizedConfirmButton) {
        <ng-container *ngTemplateOutlet="customizedConfirmButton"></ng-container>
      } @else if (confirmText) {
        <cs-button
          [attr.mat-dialog-close]="dialogRef ? '' : null"
          [label]="confirmText"
          [color]="color"
          (buttonClick)="onConfirm()"
        ></cs-button>
      }
    </div>
  </div>
</div>
